import { Component, OnInit, ViewChild, ElementRef, Optional, Inject } from '@angular/core';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { IPDService } from 'app/ipd/Services/ipdServices.service';
import { registrationService } from '../Services/registration.service';
import { AuthService } from 'app/auth/auth.service';
import { imageworkupService } from 'app/EMR/Image_workup/Services/Imageworkup.services';
import { WebSocketService } from 'app/EMR/webSocket.Service';


@Component({
  selector: 'app-webcam_photo',
  templateUrl: './webcam_photo.component.html',
  styleUrls: ['./webcam_photo.component.scss']
})
export class Webcam_photoComponent implements OnInit {
  mainUrl: any;
  url = "./assets/img/noimage.png";
  @ViewChild("video", { static: false })
  public video: ElementRef;

  @ViewChild("canvas", { static: false })
  public canvas: ElementRef;
  blob: any;
  public captures: Array<any>;
  closecamera: any;
  enablebutton: boolean = false;
  PatientId: any;
  folderName: string;
  branchId: any;
  isclosebtn: boolean;
  @ViewChild('Oldphotos') el: ElementRef;
  public constructor(public opdService: OpdVisitService,
    public dialog: MatDialog, public ipdservice: IPDService,
    public dialogRef: MatDialogRef<Webcam_photoComponent>,
    public dashboardService: DashboardService, public http: HttpClient,
    private route: ActivatedRoute, public registerService: registrationService, public authService: AuthService, public imageWorkupService: imageworkupService, private opdvisitService: OpdVisitService, private webSocketService: WebSocketService , @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
 ) {
    this.captures = [];
    this.isclosebtn = true;
  }

  public ngOnInit() {
    // this.authService.webstorageConfigobj.storageType='server';
    if (this.route.snapshot.queryParamMap.get('PID')) {

      this.isclosebtn = false;
      this.folderName = this.route.snapshot.queryParamMap.get('PatientDocuments');
      this.branchId = this.route.snapshot.queryParamMap.get('BID');
      this.PatientId = this.route.snapshot.queryParamMap.get('PID');

      this.opdService.patientdetails.pkRegId = this.PatientId;
      // this.PatientId = this.opdService.patientdetails.pkRegId;
      //  this.dashboardService.getsummary_url().subscribe(data => this.success_docurl(data), err => this.failed_docurl(err))

    }

    else if(this.data){
      console.log(this.data,"shhshhshsdadaddad")
      this.isclosebtn = true;
      this.folderName = this.data.folderName;
      this.branchId = this.data.branchId;
      this.PatientId = this.data.patientId;

      this.opdService.patientdetails.pkRegId = this.data.patientId;
    }
    else {
      // console.log('els')
      this.isclosebtn = true;
      this.PatientId = this.opdService.patientdetails.pkRegId;
      this.folderName = 'PATIENTPHOTO';
    }
    if (this.PatientId) {
      // this.documentURL();
      this.success_docurl();
      // this.get_old_photo();
    }


  }
 
  get_old_photo() {
    this.opdService.dataSource = [];
    if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
      this.imageWorkupService.getAzureImagedata(this.PatientId, this.authService.Loggeduser.branchid, this.folderName).subscribe(
        (data: any) => {
          this.opdService.dataSource = data;
          if (this.opdService.dataSource.length > 0) {
            var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
            if (mainimagepath.length > 0) {
              const msg = { "message": "UPLOADFILE", "ACTIONTYPE": "VIEWFILE", "DOCUMENTNAME": this.opdService.dataSource[0].documentName, "DOCUMENTTYPE": this.folderName.toUpperCase(), "BranchId": this.authService.Loggeduser.branchid.toString(), "PATIENTID": this.PatientId.toString(), "MAINIMAGEPATH": mainimagepath[0]?.propertyValue, }
              this.webSocketService.sendMessage(msg);
              this.webSocketService.getMessages().subscribe(
                (message: any) => {
                  const filedat = message;
                  if (Array.isArray(filedat)) {
                    this.url = message[0].fbLong ? message[0].fbLong : message[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
                  }

                }, err => {
                  this.dashboardService.openSnackBar("Please set server configuration", "OK");
                });
            } else {
              this.dashboardService.openSnackBar("Please set MainImagePath", "OK");
            }
          } else {
            this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
          }
        }, err => {

        });

    } else {
      this.imageWorkupService.getAzureImagedata(this.PatientId, this.authService.Loggeduser.branchid, this.folderName).subscribe(
        (data: any) => {
          this.opdService.dataSource = data;
          if (data.length > 0) {
            this.url = data[0].fbLong ? data[0].fbLong : data[0].documentURL + "?" + Math.floor(Math.random() * 100) + 1;
          } else {
            this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
          }
        }, err => {

        });
    }
    //  this.opdService.getoldphoto().subscribe(
    //   data => this.success_old_photo(data), err => this.failed_old_photo(err)
    // );

  }

  // success_old_photo(data) {
  //   if (data.statusCode == 1) {
  //     this.url = this.mainUrl + 'PatientPhoto/' + data.message + "?" + Math.floor(Math.random() * 100) + 1;
  //   } else {
  //     this.url = "./assets/img/noimage.png" + "?" + Math.floor(Math.random() * 100) + 1;
  //   }
  // }
  // failed_old_photo(err) {

  //   this.url = "./assets/img/noimage.png";

  // }

  // public ngAfterViewInit() {
  //     if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  //         navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
  //             this.closecamera=stream;
  //             this.video.nativeElement.srcObject = stream;
  //             this.video.nativeElement.play();
  //         });
  //     }
  // }
  base64toBlob(base64, filename = 'haha.jpeg', format = 'jpeg') {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: format });
  }


  public capture() {
    this.captures = [];
    this.retakeImage = true;
    this.enablebutton = true;
    var context = this.canvas.nativeElement.getContext("2d").drawImage(this.video.nativeElement, 0, 0, 640, 480);
    this.captures.push(this.canvas.nativeElement.toDataURL("image/jpeg"));

    const base64 = this.canvas.nativeElement.toDataURL("image/jpeg", 0.9);
    this.url = base64;
    console.log("base 64 " + base64);
    this.blob = this.base64toBlob(base64);

    // let image = this.canvas.nativeElement.toDataURL("image/jpeg");
    // var link = document.createElement('a');
    // link.download = "web-cam-img.jpeg";
    // link.href = image;
    // link.click();

  }

  uploadImage() {
    // 
    // this.opdService.deletepatientphoto(this.opdService.patientdetails.pkRegId);
    const formData = new FormData();
    // formData.append('file', this.blob);
    // formData.append('patientid',  this.PatientId.toString());
    // this.registerService.uploaddocument(formData).subscribe(
    // data=> this.successfileupload(data), err=> this.failedfileupload(err)); 
    if (this.authService.webstorageConfigobj.storageType != null && this.authService.webstorageConfigobj.storageType != undefined) {
      if (this.authService.webstorageConfigobj.imageFileSize != null && this.authService.webstorageConfigobj.imageFileSize != undefined && Number(this.authService.webstorageConfigobj.imageFileSize) > 0) {
        if (Number(this.authService.webstorageConfigobj.imageFileSize) * 1024 >= this.blob.size) {

          formData.append('file', this.blob,);
          formData.append('documentname', this.blob.name);
          formData.append('patientid', this.PatientId.toString());
          formData.append('branchId', this.authService.Loggeduser.branchid.toString());
          formData.append('DocumentType', this.folderName);
          formData.append('FolderNameMain', this.folderName);
          formData.append('UserId', this.authService.Loggeduser.userid.toString());
          formData.append('PkTranId', this.opdService.dataSource.length > 0 ? this.opdService.dataSource[0].pk_TranId.toString() : '0');
          formData.append('ActionType', "UPLOAD");
          formData.append('StorageType', this.authService.webstorageConfigobj.storageType);
          formData.append('DocumentURL', this.opdService.mainUrl);
          if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'server') {
            this.imageWorkupService.uploadDoc(formData)
              .subscribe(
                data => this.successfileupload(data), err => this.failedfileupload(err))
          } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'azure') {
            this.imageWorkupService.uploadAzureDoc(formData)
              .subscribe(
                data => this.successfileupload(data), err => this.failedfileupload(err))
          } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'aws') {

          } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {

            var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
            if (mainimagepath.length > 0) {
              if (mainimagepath[0]?.propertyValue) {
                const splitdata = this.url.split(',');
                const docname = String(this.PatientId) + '.png'
                const message = {
                  "message": "UPLOADFILE",
                  "ACTIONTYPE": "UPLOAD",
                  "DOCUMENTTYPE": this.folderName.toUpperCase(),
                  "BranchId": this.authService.Loggeduser.branchid.toString(),
                  "PATIENTID": this.PatientId.toString(),
                  "MAINIMAGEPATH": mainimagepath[0]?.propertyValue,
                  "DOCUMENTNAME": String(docname),
                  "CLIENTFILE": String(docname),
                  "fileData": String(splitdata[1])
                };

                this.webSocketService.sendMessage(message);
                this.webSocketService.getMessages().subscribe(
                  (message: any) => {

                    if (message) {
                      this.dashboardService.openSnackBar(message, "OK");
                      this.webSocketService.disconnect();
                      let payload = {
                        "PatientDocumentDetail": {
                          "ActionType": "UPLOAD",
                          "Pk_TranId": this.opdService.dataSource.length > 0 ? this.opdService.dataSource[0].pk_TranId.toString() : '0',
                          "Fk_BranchId": this.authService.Loggeduser.branchid.toString(),
                          "Fk_RegId": this.PatientId.toString(),
                          "Fk_CreatedById": this.authService.Loggeduser.userid,
                          "DocumentType": this.folderName.toUpperCase(),
                          "DocumentName": String(docname),
                          "StorageType": this.authService.webstorageConfigobj.storageType,
                          "DocumentURL": mainimagepath[0]?.propertyValue + '/' + this.folderName.toUpperCase() + '/' + docname
                        }
                      }
                      this.imageWorkupService.UpdatePatientDocumentDetail(payload).subscribe((x: any) => {
                        setTimeout(() => {
                          this.get_old_photo();
                        }, 500);

                      });

                    }

                  }, err => {

                    this.dashboardService.openSnackBar("Please set server configuration", "OK");
                  });
              } else {
                this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
              }
            } else {
              this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
            }
          } else {
            this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Maximum File Size Allowed " + this.authService.webstorageConfigobj.documentFileSize + ' Kb', "OK");
        }
      } else {
        this.dashboardService.openSnackBar("Document File Size Not Configured", "OK");
      }
    } else {
      this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
    }

  }

  successfileupload(data) {
    if (this.route.snapshot.queryParamMap.get('PID')) {
      this.opdService.patientdetails.pkRegId = this.PatientId;
      this.get_old_photo();
    }
    else {
      this.PatientId = this.opdService.patientdetails.pkRegId;
      this.get_old_photo();
    }

    this.url = "";
    this.dashboardService.openSnackBar(" Uploaded Successfully", "OK");
  }

  failedfileupload(err) {
    this.dashboardService.openSnackBar("Upload Failed", "OK");
  }

  onNoClick(): void {
    // if(this.closecamera!=undefined) {
    //   this.closecamera.getTracks().forEach(function(track) {
    //     if (track.readyState == 'live') {
    //         track.stop();
    //     }
    // });

    // }

    this.dialogRef.close();
  }
  // documentURL() {
  //   this.dashboardService.getdocument_url().subscribe(data => this.success_docurl(data), err => this.failed_docurl(err));
  // }

  success_docurl() {
    this.get_old_photo();

    var urldoc = this.opdvisitService.documentrul.filter(item => item.propertyName == "MainImagePathWebNetram")
    this.mainUrl = urldoc[0]?.propertyValue;
  }
  failed_docurl(err) {

  }



  //Take Photo Modal
  takePhotoModalDialog() {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
        this.closecamera = stream;
        this.video.nativeElement.srcObject = stream;
        this.video.nativeElement.play();
      });
    }
    document.getElementById("takePhotoModal").style.display = "block";
  }
  closetakePhotoModalDialog() {
    if (this.closecamera != undefined) {
      this.closecamera.getTracks().forEach(function (track) {
        if (track.readyState == 'live') {
          track.stop();
        }
      });

    }
    document.getElementById("takePhotoModal").style.display = "none";
  }

  retakeImage: boolean;

  retakePhoto() {
    this.retakeImage = false;
  }

  //Old Photos Modal
  oldPhotosModalDialog() {
    document.getElementById("oldPhotoModal").style.display = "block";
  }
  closeoldPhotosModalDialog() {
    document.getElementById("oldPhotoModal").style.display = "none";
  }


  //Old Photos Modal
  deleteProfilePhotoModalDialog() {
    document.getElementById("deleteProfilePhotoModal").style.display = "block";
  }
  closedeleteProfilePhotoModalDialog() {
    document.getElementById("deleteProfilePhotoModal").style.display = "none";
  }
  readFileAsDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }
  async onFileChange(event: any) {
    if (this.opdService.patientdetails.pkRegId) {
      if (event.target.files.length > 0) {
        const filedata = event.target.files[0];
        const formData = new FormData();
        this.url = await this.readFileAsDataURL(event.target.files[0]);

        // formData.append('file', filedata);
        // formData.append('patientid', this.opdService.patientdetails.pkRegId?.toString());
        // this.registerService.uploaddocument(formData).subscribe(
        //   data => this.successfileuploadd(data), err => this.failedfileuploadd(err)
        // )

        if (this.authService.webstorageConfigobj.storageType != null && this.authService.webstorageConfigobj.storageType != undefined) {
          if (this.authService.webstorageConfigobj.imageFileSize != null && this.authService.webstorageConfigobj.imageFileSize != undefined && Number(this.authService.webstorageConfigobj.imageFileSize) > 0) {
            if (Number(this.authService.webstorageConfigobj.imageFileSize) * 1024 >= filedata.size) {

              formData.append('file', filedata,);
              formData.append('documentname', filedata.name);
              formData.append('patientid', this.PatientId.toString());
              formData.append('branchId', this.authService.Loggeduser.branchid.toString());
              formData.append('DocumentType', this.folderName);
              formData.append('FolderNameMain', this.folderName);
              formData.append('UserId', this.authService.Loggeduser.userid.toString());
              formData.append('PkTranId', this.opdService.dataSource.length > 0 ? this.opdService.dataSource[0].pk_TranId.toString() : '0');
              formData.append('ActionType', "UPLOAD");
              formData.append('StorageType', this.authService.webstorageConfigobj.storageType);
              formData.append('DocumentURL', this.opdService.mainUrl);
              if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'server') {
                this.imageWorkupService.uploadDoc(formData)
                  .subscribe(
                    data => this.successfileuploadd(data), err => this.failedfileupload(err))
              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'azure') {
                this.imageWorkupService.uploadAzureDoc(formData)
                  .subscribe(
                    data => this.successfileuploadd(data), err => this.failedfileupload(err))
              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'aws') {

              } else if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {

                var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
                if (mainimagepath.length > 0) {
                  if (mainimagepath[0]?.propertyValue) {
                    const splitdata = this.url.split(',');
                    const docname = String(this.PatientId) + '.png'
                    const message = {
                      "message": "UPLOADFILE",
                      "ACTIONTYPE": "UPLOAD",
                      "DOCUMENTTYPE": this.folderName.toUpperCase(),
                      "BranchId": this.authService.Loggeduser.branchid.toString(),
                      "PATIENTID": this.PatientId.toString(),
                      "MAINIMAGEPATH": mainimagepath[0]?.propertyValue,
                      "DOCUMENTNAME": String(docname),
                      "CLIENTFILE": String(docname),
                      "fileData": String(splitdata[1])
                    };

                    this.webSocketService.sendMessage(message);
                    this.webSocketService.getMessages().subscribe(
                      (message: any) => {

                        if (message) {
                          this.dashboardService.openSnackBar(message, "OK");
                          this.webSocketService.disconnect();
                          let payload = {
                            "PatientDocumentDetail": {
                              "ActionType": "UPLOAD",
                              "Pk_TranId": this.opdService.dataSource.length > 0 ? this.opdService.dataSource[0].pk_TranId.toString() : '0',
                              "Fk_BranchId": this.authService.Loggeduser.branchid.toString(),
                              "Fk_RegId": this.PatientId.toString(),
                              "Fk_CreatedById": this.authService.Loggeduser.userid,
                              "DocumentType": this.folderName.toUpperCase(),
                              "DocumentName": String(docname),
                              "StorageType": this.authService.webstorageConfigobj.storageType,
                              "DocumentURL": mainimagepath[0]?.propertyValue + '/' + this.folderName.toUpperCase() + '/' + docname
                            }
                          }
                          this.imageWorkupService.UpdatePatientDocumentDetail(payload).subscribe((x: any) => {
                            this.get_old_photo();

                          });
                        }

                      }, err => {

                        this.dashboardService.openSnackBar("Please set server configuration", "OK");
                      });
                  } else {
                    this.dashboardService.openSnackBar('Please set MainImagePath Property value in Application Setting', 'OK');
                  }
                } else {
                  this.dashboardService.openSnackBar('Please set MainImagePath in Application Setting', 'OK');
                }
              } else {
                this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
              }
            } else {
              this.dashboardService.openSnackBar("Maximum File Size Allowed " + this.authService.webstorageConfigobj.documentFileSize + ' Kb', "OK");
            }
          } else {
            this.dashboardService.openSnackBar("Document File Size Not Configured", "OK");
          }
        } else {
          this.dashboardService.openSnackBar("Please Check Storage Configuration", "OK");
        }
      }
    }
    else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }

  }

  successfileuploadd(data) {

    this.get_old_photo();
    this.dashboardService.openSnackBar(" Uploaded Successfully", "OK");


  }
  failedfileuploadd(err) {

    this.dashboardService.openSnackBar(" Upload Failed", "OK");
  }
  deletepatientphoto(patid: any) {
  
    if (patid > 0) {
      if (this.opdService.dataSource.length > 0) {

        let payload = {
          "PatientDocumentDetail": {
            "ActionType": "DELETE",
            "Pk_TranId": this.opdService.dataSource[0].pk_TranId,
            "Fk_BranchId": this.opdService.dataSource[0].fk_BranchId,
            "Fk_RegId": this.opdService.dataSource[0].fk_RegId,
            "Fk_CreatedById": this.authService.Loggeduser.userid,
            "DocumentType": this.opdService.dataSource[0].documentType,
            "DocumentName": this.opdService.dataSource[0].documentName,
            "DocumentURL": this.opdService.dataSource[0].documentURL,
            "StorageType": this.opdService.dataSource[0].storageType
          }
        }
        if (this.authService.webstorageConfigobj.storageType.toLowerCase() == 'imageserver') {
          this.ipdservice.deleteServerPatientDocument(payload).subscribe((x: any) => {
            var mainimagepath = this.opdvisitService.documentrul.filter(item => item?.propertyName.toLowerCase() == "mainimagepath");
            if (mainimagepath.length > 0) {
              const msg = {
                "message": "UPLOADFILE",
                "ACTIONTYPE": "DELETE",
                "DOCUMENTTYPE": this.opdService.dataSource[0].documentType.toUpperCase(),
                "BranchId": this.opdService.dataSource[0].fk_BranchId.toString(),
                "PATIENTID": this.opdService.dataSource[0].fk_RegId.toString(),
                "DocumentName": this.opdService.dataSource[0].documentName.toString(),
                "MAINIMAGEPATH": mainimagepath[0]?.propertyValue
              }
              this.webSocketService.sendMessage(msg);
              this.webSocketService.getMessages().subscribe(
                (message: any) => {
                  if (message) {
                    this.webSocketService.disconnect();
                    this.get_old_photo();
                      this.dashboardService.openSnackBar("Delete Successfully", "OK");
                  }
                }, err => {
                  this.dashboardService.openSnackBar("Please set server configuration", "OK");
                });
            }else{
              this.dashboardService.openSnackBar("Please set mainimagepath", "OK");
            }

          })
        }
        else if (this.opdService.dataSource[0].storageType.toLowerCase() == 'server') {
          this.ipdservice.deleteServerPatientDocument(payload).subscribe(
            data => this.success_delete_image(data), err => this.failed_doc_delete(err));
        } else if (this.opdService.dataSource[0].storageType.toLowerCase() == 'azure') {
          this.ipdservice.deleteAzurePatientDocument(payload).subscribe(
            data => this.success_delete_image(data), err => this.failed_doc_delete(err));
        }

      } else {
        this.dashboardService.openSnackBar("No Record Found", "OK");
      }

    }
  }
  success_delete_image(data) {
    this.get_old_photo();
    this.dashboardService.openSnackBar("Delete Successfully", "OK");

  }

  failed_doc_delete(err) {
    this.dashboardService.openSnackBar(" Delete Api Failed", "OK");
  }
}
